import { useAuth0 } from "@auth0/auth0-react";

import Dialog from "@material-ui/core/Dialog";
import Tooltip from "@mui/material/Tooltip";
import AuthService from "Lib/API/Auth";
import { ReactComponent as ExportYahIcon } from "assets/icons/export_yah.svg";
import { ReactComponent as LetterYahIcon } from "assets/icons/letter_yah.svg";
import { ReactComponent as PrintYahIcon } from "assets/icons/print_yah.svg";
import { ReactComponent as LineYahIcon } from "assets/icons/yah_line.svg";
import AlertDialog from "components/Dialog";
import Button from "components/button/Button.jsx";
import RightDrawer from "components/drawer";
import { formatDate } from "helper/dateFormat.js";
import * as _ from "lodash";
import React, { useEffect, useMemo, useRef } from "react";
import { formatPhoneNumber } from 'react-phone-number-input';
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { DateFormetContext } from "../../app/App.js";
import { setOpenRecipients, setSelectedDeceased } from "../commonSlice";
import AddMourner from "./AddMourner/AddMourner";
import DeceasedTableList from "./DeceasedTableList.jsx";
import YahrzietDrawer from "./YahrzietDrawer";
import DeceasedLetter from "./deceasedLetter";
import Recipients from "./deceasedLetter/Recipients";
import "./yaherzitStyle.scss";

const DeceasedTable = ({
  refresh,
  setRefresh,
  loading,
  list,
  page,
  setPage,
  total,
  sortBy,
  setFilters,
  endDate,
  searchValue,
  filters,
  onCheckboxClick,
  totalMourner,
  ...props
}) => {
  const location = useLocation();
  const history = useHistory();
  const [openModal, setOpenModal] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openDiscardChanges, setOpenDiscardChanges] = React.useState(false);
  const [touched, setTouched] = React.useState({});
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [csvData, setExportData] = React.useState([]);
  const [deceasedId, setDeceasedId] = React.useState("");
  const [exportType, setExportType] = React.useState("");
  const dateFormet = React.useContext(DateFormetContext);
  const [search_item_id, setSearch_item_id] = React.useState(null);
  const [openLetterModal, setOpenLetterModal] = React.useState(false);
  const [openAddMournerModal, setOpenAddMournerModal] = React.useState(false);
  const [openAddMournerSource, setOpenAddMournerSource] = React.useState("table");
  const [addMournerSuccess, setAddMournerSuccess] = React.useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [check, setCheck] = React.useState([]);
  const [mournersList, setMournersList] = React.useState([]);
  const [printLoading, setPrintLoading] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(false);
  const [exportDeceased, setExportDeceased] = React.useState([]);
  const [exportLoading, setExportLoading] = React.useState(false);
  const [filterDeceasedLoading, setFilterDeceasedLoading] = React.useState(false);
  const [confirmClose, setConfirmClose] = React.useState(false);
  const [selectedMourner, setSelectedMourner] = React.useState(null);
  const [manageMournerType, setManageMournerType] = React.useState("create");

  const openRecipients = useSelector(
    (state) => state.CommonStates.openRecipients
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    if (_.isEmpty(touched)) {
      setOpenModal(false);
      setSearch_item_id(null);
    } else {
      setOpenDiscardChanges(true);
    }
  };

  const getFilteredDeceasedExport = async (type) => {
    setExportLoading(true);
    const token = await getAccessTokenSilently();
    AuthService.getFilteredDeceasedExport(filters, sortBy, token)
      .then((res) => {
        const result = res?.deceaseds;
        setExportDeceased(result);
        setExportType(type);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  const getFilteredDeceased = async () => {
    setFilterDeceasedLoading(true);
    const token = await getAccessTokenSilently();
    AuthService.getFilteredDeceasedExport(filters, sortBy, token)
      .then((res) => {
        const result = res?.deceaseds;
        setOpenLetterModal(true);
        dispatch(setSelectedDeceased(result));
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      })
      .finally(() => {
        setFilterDeceasedLoading(false);
      });
  };
  const handleDelete = async () => {
    setOpenModal(false);
    const token = await getAccessTokenSilently();
    await AuthService.removeDeceased({ deceasedID: deceasedId }, token)
      .then((res) => {
        if (res) {
          setOpen(false);
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        setOpen(false);
      });
  };

  useEffect(() => {
    setCheck([]);
    setCheckAll(false);
    dispatch(setSelectedDeceased([]));
  }, [sortBy, filters]);


  React.useEffect(() => {
    const param = new URLSearchParams(location.search).get("q");
    if (!param) return;
    setSearch_item_id(param);
  }, [location.search]);
  React.useEffect(() => {
    if (!search_item_id) return;
    setDeceasedId(search_item_id);
    setOpenModal(true);
    const newLocation = { ...location, search: "" };
    history.replace(newLocation);
  }, [search_item_id]);

  const openAddMournerModalHandler = (mourners, type = "create", selectedMourner) => {
    setOpenAddMournerModal(true);
    setOpenAddMournerSource("drawer");
    const filteredMourner = mourners.map((item) => {
      return {
        ...item,
        memberId: item?._id,
      };
    });
    setMournersList(filteredMourner);
    setSelectedMourner(selectedMourner);
    setManageMournerType(type);
  }

  const closeOpenAddMournerModalHandler = () => {
    setOpenAddMournerModal(false);
    setOpenAddMournerSource("table");
    setMournersList([]);
    setSelectedMourner(null);
    setManageMournerType("create");
  }


  const downloadYahrzeitsHandler = async (row) => {
    if (printLoading) return;
    setPrintLoading(true);
    const token = await getAccessTokenSilently();
    const ids = check.map((item) => item._id);
    await AuthService.downloadYahrzeits({
      token, sortBy: sortBy, filters: {
        ...filters,
        filter: {
          ...filters?.filter,
          ids,
        }
      }
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const currentDate = formatDate({ date: new Date(), formatType: "defaultWithUTC" });
      const fileName = `yahrzeits_${currentDate}`;
      link.setAttribute('download', `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    }).catch((error) => {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    })
      .finally(() => {
        setPrintLoading(false);
      })

  }

  const exportData = (data) => {
    let exportList = [];
    const deceased = data?.map((item) => {
      return item?.mourners_list?.map((li) => {
        const d = {
          firstName:
            item?.firstName,
          lastName:
            item?.lastName,
          observanceFirstName: li?.member_id?.first_name ? li?.member_id?.first_name : "Guest",
          observanceLastName: li?.member_id?.last_name ? li?.member_id?.last_name : "Guest",
          eng_date: formatDate({ date: item?.date_of_death, formatType: "defaultWithUTC" }),
          hebrew_name: item?.hebrew_name_of_Death,
          hebrew_date: item?.hebrew_date_of_death,
          relation: li?.relation,
          next_english_yhartzeit: item?.next_english_yhartzeit
            ? formatDate({ date: item?.next_english_yhartzeit, formatType: "defaultWithUTC" })
            : "",
          next_hebrew_yhartzeit: item?.next_hebrew_yhartzeit
            ? formatDate({ date: item?.next_hebrew_yhartzeit, formatType: "defaultWithUTC" })
            : "",
          observance: li?.observance,
          has_plaque: item?.plaque_number,
          yhartzeit_number:
            item.date_of_death !== undefined || null
              ? new Date().getFullYear() -
              new Date(item?.date_of_death).getFullYear()
              : "",
          mobile_phone: formatPhoneNumber(li?.member_id?.mobile_number),
          home_phone: formatPhoneNumber(li?.member_id?.home_phone),
          email_address: li?.member_id?.email_address,
          address: li?.member_id?.location?.formattedAddress?.split(",")[0],
          addressLine2: li?.member_id?.addressLine2 || "",
          city: li?.member_id?.city,
          state: li?.member_id?.state,
          zip_code: li?.member_id?.zip_code,
          account_type: li?.member_id?.account?.payment?.account_type,
          doesnt_have_mourner: item?.doesnt_have_mourner,
          sent: item?.sent?.status ? item?.sent?.status : "",
          sent_at: item?.sent?.date
            ? formatDate({ date: item?.sent?.date, formatType: "defaultWithTime" })
            : "",
        };
        exportList.push(d);
      });
    });
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(exportList));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      "yahrzeits.xlsx"
    );
  }

  const exportAllData = () => {
    getFilteredDeceasedExport("exportAll")
  }

  const onExportDataHandler = () => {
    checkAll ? exportAllData() : exportData(check)
  }

  useEffect(() => {
    if (exportType === "exportAll" && exportDeceased?.length > 0) {
      exportData(exportDeceased)
    }
    setExportType("");
  }, [exportType]);

  const calculateTotalMourner = () => {
    let totalMourner = 0;
    const allMourners = check?.forEach((item) => {
      totalMourner += item?.mourners_list?.length;
    });
    return totalMourner;
  }

  const isLimitReached = useMemo(() => {
    return checkAll ? totalMourner > 500 : calculateTotalMourner() > 500;
  }, [checkAll, totalMourner, check]);



  const onSendLetterClick = () => {
    checkAll ? getFilteredDeceased() : setOpenLetterModal(true)
  }

  const displayTotalMourner = useMemo(() => checkAll ? totalMourner : calculateTotalMourner(), [checkAll, totalMourner, check]);

  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    closeOpenAddMournerModalHandler();
  }

  return (
    <div className="w-100 yahrzeti-page">
      <div className="family-table-container p-7">
        <div className="home-table-container mt-0">
          <div className="d-flex justify-content-between mb-4">
            <div className="yah-sub">
              Upcoming yahrzeits
              <span className="yah__total ml-5">{total} Yahrzeits</span>
            </div>
            <div className="options">
              {(check?.length || checkAll) ? (
                <>
                  <Tooltip
                    title="Contact limit is 500; apply filters to create smaller list."
                    disableHoverListener={true}
                  >
                    <Button
                      onClick={() => {
                        // if (isLimitReached) return;
                        onExportDataHandler()
                      }}
                      // disabled={isLimitReached}
                      variant="secondary-light"
                      size="md"
                      className="mr-5"
                    >
                      {exportLoading ? (
                        <span className="mr-6 spinner spinner-primary"></span>
                      ) : (
                        <>
                          <ExportYahIcon className="mr-1" />
                          <span>Export</span>
                        </>
                      )}
                    </Button>
                  </Tooltip>
                  <Tooltip
                    title="Contact limit is 500; apply filters to create smaller list."
                    disableHoverListener={true}
                  >
                    <Button
                      onClick={() => {
                        // if (isLimitReached) return;
                        downloadYahrzeitsHandler()
                      }}
                      disabled={printLoading}
                      variant="secondary-light"
                      size="md"
                    >
                      {printLoading ? (
                        <span className="mr-6 spinner spinner-primary"></span>
                      ) : (
                        <>
                          <PrintYahIcon className="mr-2" />
                          <span>Print</span>
                        </>
                      )}
                    </Button>
                  </Tooltip>
                  <LineYahIcon className="mx-5" />
                  <Tooltip
                    title="Contact limit is 500; apply filters to create smaller list."
                    disableHoverListener={!isLimitReached}
                  >
                    <Button
                      onClick={() => {
                        if (isLimitReached) return;
                        onSendLetterClick();
                      }}
                      disabled={isLimitReached}
                      variant="secondary-light"
                      size="md"
                    >
                      {filterDeceasedLoading ? (
                        <span className="mr-6 spinner spinner-primary"></span>
                      ) : (
                        <>
                          <LetterYahIcon className="mr-1" />
                          Send Letter: {displayTotalMourner}
                        </>
                      )}
                    </Button>
                  </Tooltip>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <DeceasedTableList
            list={list}
            loading={loading}
            total={total}
            page={page}
            setPage={setPage}
            checkAll={checkAll}
            check={check}
            setCheckAll={setCheckAll}
            setCheck={setCheck}
            onCheckboxClick={onCheckboxClick}
            setFilters={setFilters}
            setOpenModal={setOpenModal}
            setOpen={setOpen}
            setMournersList={setMournersList}
            setDeceasedId={setDeceasedId}
            setOpenAddMournerModal={setOpenAddMournerModal}
          />
        </div>
        <AlertDialog
          open={open}
          handleClose={() => setOpen(false)}
          onDecline={() => {
            setOpen(false);
          }}
          onAccept={handleDelete}
          title="Are you sure?"
          description={"Do you want to Delete this item?"}
        />
        <RightDrawer open={openModal} onClose={handleClose}>
          <YahrzietDrawer
            open={openDiscardChanges}
            setOpen={setOpenDiscardChanges}
            setOpenAlert={setOpen}
            setTouched={setTouched}
            setOpenDrawer={setOpenModal}
            deceasedId={deceasedId}
            refresh={refresh}
            setRefresh={setRefresh}
            isEdit={"true"}
            openAddMournerModal={openAddMournerModalHandler}
            addMournerSuccess={addMournerSuccess}
            setAddMournerSuccess={setAddMournerSuccess}
          />
        </RightDrawer>
      </div>
      <Dialog
        open={openLetterModal}
        onClose={() => {
          setOpenLetterModal(false);
          dispatch(setSelectedDeceased([]));
          setCheck([]);
        }}
        PaperProps={{
          style: {
            width: "888px",
            height: "637px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <DeceasedLetter
          openLetterModal={openLetterModal}
          setOpenLetterModal={setOpenLetterModal}
          setCheck={setCheck}
        />
      </Dialog>
      <Dialog
        open={openRecipients}
        onClose={() => {
          dispatch(setOpenRecipients(false));
          dispatch(setSelectedDeceased([]));
          setCheck([]);
        }}
        PaperProps={{
          style: {
            width: "574px",
            height: "637px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
      >
        <Recipients />
      </Dialog>
      <Dialog
        open={openAddMournerModal}
        onClose={closeModal}
        PaperProps={{
          style: {
            width: "450px",
            height: "570px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <AddMourner
          deceasedId={deceasedId}
          onAddSuccess={() => {
            if (openAddMournerSource === "drawer") {
              setAddMournerSuccess(true);
              setOpenAddMournerModal(false);
              setRefresh(!refresh);
            }
            setOpenAddMournerModal(false);
          }}
          closeModal={closeModal}
          selectedMourners={mournersList || []}
          selectedMourner={selectedMourner}
          type={manageMournerType}
        />
      </Dialog>
      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};

export default DeceasedTable;
